import Cookies from "js-cookie";
import jwt from "jwt-decode";
import jwtDecode from "jwt-decode";
import { login } from "../api/authentication/authentication";
import { DialogSelected } from "../constant/common";
import { environment } from "../constant/environment";
import { Messages } from "../constant/messages/toastMessages";
import { toastMessage } from "../helpers/toast/toastMessage";
import { getItemFromLocalStorage, setItemInLocalStorage } from "../hooks/localStorage";
import { LoginResponse } from "../interface";
import { UserInfo } from "../types";
import { decryptData } from "./api/encryption";
import { isValidJWT } from "./authentication/isValidJWT";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../constant/google-analytics/GAEvents";
import { consoleLog } from "./consoleLog/consoleLog";

// Get JWT from local storage
export function checkIfUserIsLoggedIn(setIsValidAccessToken: any, setUserInfo: (userInfo: UserInfo) => void): void {
  const userJWT = getItemFromLocalStorage("_zenvoya_JWT");

  if (userJWT && isValidJWT(userJWT)) {
    const decryptedToken = decryptData(userJWT);
    const decodedToken: any = jwtDecode(decryptedToken);
    setIsValidAccessToken(true);
    setUserInfo({
      id: decodedToken.id,
      name: decodedToken.name,
      email: decodedToken.email,
      phone: "",
      profile_pic: "",
      loggedIn: true,
      role: decodedToken?.role || 0,
    });
    /**
     * post message data
     */
    if (window && window.parent) {
      const message = {
        action: "CheckIfUserIsLoggedIn",
        data: decodedToken,
      };
      window.parent.postMessage(JSON.stringify(message)); // or specify a specific origin instead of "*"
    }
  } else {
    setIsValidAccessToken(false);
    setItemInLocalStorage("_zenvoya_JWT", "");
    setUserInfo({
      id: "",
      name: "",
      email: "",
      phone: "",
      profile_pic: "",
      loggedIn: false,
      role: 0,
      preferences: {},
    });
  }
}

//  check log in and making API call
export async function checkLogin({
  sendPixelEvent,
  setIsValidAccessToken,
  setAccessJWT,
  accessJWT,
  email,
  loginType,
  name,
  password,
  setUserInfo,
  setIsLoggedIn,
  signInClick,
  setLoginCreateAccountState,
  loginCreateAccountState,
  setSignInClick,
  loginFailureMessage,
  utmParams,
  setPasswordError,
}: any) {
  const payLoad = {
    email: email?.trim() || "",
    loginType: loginType,
    name: name?.trim() || "",
    password: password?.trim() || "",
    utmParams: utmParams || "",
  };
  const response: LoginResponse = await login(accessJWT, payLoad);
  consoleLog(["LOG IN CHECK LOGIN", response]);
  if (response?.message === "Email id does not exists") {
    setLoginCreateAccountState({
      ...loginCreateAccountState,
      page: DialogSelected.CREATE_ACCOUNT,
    });
    toastMessage.error("OOPS!", "Email id not registered, please signup.");
    return null;
  }
  if (response?.message === "Wrong password" && setPasswordError) {
    toastMessage.error("OOPS!", "Wrong password");
    setPasswordError(Messages["login.failure"].message);
    return null;
  }
  // Email verification gate: the account is unverified and email verification is
  // on. The backend has already sent an OTP; hand the caller the signal so it can
  // drive the verify step (no session issued). Only occurs for email login.
  if ((response as any)?.data?.needsVerification) {
    return {
      needsVerification: true,
      userId: (response as any)?.data?.userId,
      email,
    };
  }
  if (response?.message !== "Login successfull") {
    toastMessage.error("Sorry!", "We were unable to log you in. Please try again.");
    return null;
  }

  if (response?.message === "Login successfull") {
    const checkExistingUser = response?.data?.existingUser;
    consoleLog(["LOG IN GOOGLE check exist", response, checkExistingUser]);
    if (!checkExistingUser) {
      if (loginType === "Google") {
        triggerGAEvent(GA_LABEL_ENUMS.signup_complete_google, "", "", "", {
          full_name: name,
          email: email,
          traffic_source: utmParams?.match(/utm_source=([^&]+)/)?.[1] || "",
        });
        sendPixelEvent("signUp", { method: GA_LABEL_ENUMS.signup_complete_google, email: email });
      } else if (loginType === "Apple") {
        triggerGAEvent(GA_LABEL_ENUMS.signup_complete_apple, "", "", "", {
          full_name: name,
          email: email,
          traffic_source: utmParams?.match(/utm_source=([^&]+)/)?.[1] || "",
        });
        sendPixelEvent("signUp", { method: GA_LABEL_ENUMS.signup_complete_apple, email: email });
      } else if (loginType === "Facebook") {
        triggerGAEvent(GA_LABEL_ENUMS.signup_complete_facebook, "", "", "", {
          full_name: name,
          email: email,
          traffic_source: utmParams?.match(/utm_source=([^&]+)/)?.[1] || "",
        });
        sendPixelEvent("signUp", { method: GA_LABEL_ENUMS.signup_complete_facebook, email: email });
      }
      consoleLog("New User Signup completed - GA event triggered");
    }
    const decodedToken: any = jwt(decryptData(response?.data?.jwtToken) || response?.data);
    consoleLog(["LOG IN CHECK LOGIN TOKEN", decodedToken]);
    setIsValidAccessToken(true);
    const userInfoData = {
      id: decodedToken.id,
      name: decodedToken.name,
      email: decodedToken.email,
      existingUser: checkExistingUser,
      loggedIn: true,
      loginType: response?.data?.loginType,
    };
    setUserInfo((prev: any) => ({
      ...prev,
      ...userInfoData,
    }));
    // setLoginCreateAccountState((pre: any) => ({
    //   flag: false,
    //   page: "",
    // }));
    setIsLoggedIn(true);

    /**
     * post message data
     */
    if (window && window.parent) {
      const message = {
        action: "LogIn",
        data: userInfoData,
      };
      const iframe: HTMLIFrameElement | null = document.querySelector("#app_domain");
      const wind = iframe?.contentWindow;
      const data = {
        ...userInfoData,
        jwt: response?.data?.jwtToken || response?.data,
      };
      // testing cookies
      Cookies.set(`${environment}userData`, JSON.stringify(data), {
        path: "/",
        expires: 700,
        domain: ".zenvoya.ai",
      });
      wind?.postMessage(JSON.stringify(data), "*");
      window.parent.postMessage(JSON.stringify(message)); // or specify a specific origin instead of "*"
    }

    // store the JWT to local storage
    consoleLog([
      "LOG IN CHECK LOGIN TOKEN COrrect",
      response?.data?.jwtToken || response?.data,
      response?.data?.jwtToken,
      response?.data,
    ]);
    setItemInLocalStorage("_zenvoya_JWT", response?.data?.jwtToken || response?.data);
    setAccessJWT(response?.data?.jwtToken || response?.data);

    if (signInClick && checkExistingUser) {
      // setLoginCreateAccountState({ ...loginCreateAccountState, flag: false });
      setSignInClick(false);
    } else if (checkExistingUser) {
      // setLoginCreateAccountState({
      //   ...loginCreateAccountState,
      //   flag: false,
      //   page: "",
      // });
    }

    return {
      id: decodedToken.id,
      isExistingUser: response?.data?.existingUser,
    };
  } else {
    toastMessage.error("OOPS", loginFailureMessage);
    return null;
  }
}

// Get Local Storage Data
export function getLocalStorageData(localItem: string, setItem?: any) {
  const localStorageData = getItemFromLocalStorage(localItem);
  if (localStorageData && setItem) {
    setItem(JSON.parse(localStorageData));
  }

  return localStorageData;
}

// Get Local Storage Data
export function getSessionStorage(localItem: string, setItem: any) {
  const localSessionData = window.sessionStorage.getItem(localItem);
  if (localSessionData) {
    setItem(JSON.parse(localSessionData));
  }

  return localSessionData;
}
